import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await completeGoogle(sessionId);
        window.history.replaceState(null, "", "/app");
        navigate("/app");
      } catch {
        setError("We could not complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/login"), 2000);
      }
    })();
  }, [completeGoogle, navigate, location.hash]);

  return (
    <div className="grid min-h-screen place-items-center bg-softcream">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-tblue border-t-transparent" />
        <p className="mt-4 text-sm text-muted">{error || "Completing sign-in…"}</p>
      </div>
    </div>
  );
}
